var _node$parentNode, _node$parentNode$pare;

/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * The entry point for the admin side wp-admin resource.
 */
import "antd/dist/antd.css";
import "./style/admin.scss";
import "@tatum/utils"; // Import once for startup polyfilling (e. g. setimmediate)

import { render } from "react-dom";
import { RootStore } from "./store";
import { Layout } from "./components";
var node = document.getElementById("".concat(RootStore.get.optionStore.slug, "-component"));
var wpContent = node === null || node === void 0 ? void 0 : (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : (_node$parentNode$pare = _node$parentNode.parentNode) === null || _node$parentNode$pare === void 0 ? void 0 : _node$parentNode$pare.parentNode;

if (wpContent) {
  wpContent.style.paddingLeft = "0";
}

if (node) {
  render( /*#__PURE__*/React.createElement(RootStore.StoreProvider, null, /*#__PURE__*/React.createElement(Layout, null)), node);
} // Expose this functionalities to add-ons, but you need to activate the library functionality
// in your webpack configuration, see also https://webpack.js.org/guides/author-libraries/


export * from "@tatum/utils";
export * from "./store";